import React from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

export const OrderItemsModal = ({ isOpen, toggle, orderItems }) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle} className="pt-4 pb-2">
        Order Items
      </ModalHeader>

      <ModalBody className="py-2">
        {orderItems?.map((item, i) => (
          <div
            key={i}
            className="p-3 mb-3 border rounded"
            style={{ background: "#fafafa" }}
          >
            {/* Item Info */}
            <div className="d-flex justify-content-between align-items-center mb-2">
              <div>
                <h6 className="mb-1 fw-bold text-sm">{item?.name}</h6>
                <small className="text-muted">
                  Size: {item?.size || "(offer)"}
                </small>
              </div>
              <div className="text-end">
                <div className="fw-bold">
                  {item?.currency || "USD"} {item?.price}
                </div>
                <small className="text-muted">Qty: {item?.quantity}</small>
              </div>
            </div>

            {/* Addons */}
            {item?.addons?.length > 0 && (
              <div
                className="p-2 mt-2 border rounded"
                style={{ background: "#fff", borderLeft: "4px solid #0d6efd" }}
              >
                <div className="fw-bold text-primary mb-2 text-xs">Addons</div>
                {item?.addons?.map((addon, j) => (
                  <div
                    key={j}
                    className="d-flex justify-content-between align-items-center py-1"
                  >
                    <div className="text-muted">↳ {addon?.name}</div>
                    <div className="text-end">
                      <div>
                        {item?.currency || "USD"} {addon?.price}
                      </div>
                      <small className="text-muted">
                        Qty: {addon?.quantity}
                      </small>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </ModalBody>

      <ModalFooter className="py-2">
        <Button color="danger" onClick={toggle}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};
